export default {"src":"/_next/static/media/exterior-redesign.86c80776.svg","height":22,"width":29,"blurWidth":0,"blurHeight":0};